let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cwpgX"), load("8makw"), load("heWL2")]).then(() => parcelRequire('dHxkf'));